export enum EnvName {
  LOCAL = 'local',
  DEV = 'dev',
  INT = 'int',
  DEMODEV = 'demodev',
  DEMO = 'demo',
  PRD = 'prd'
}
